import { IStore } from 'store/types';
import { IPOSCategories } from 'types';

export const selectPOSCategories =
  () =>
  (state: IStore): IPOSCategories | undefined =>
    state?.collections?.posCategories;
